<template>
  <div class="">
    <!-- 菜单栏（内嵌App时隐藏） -->
    <div class="container_box">
      <app-header bgcolor="" :transparent="true" :title="title" back-type="back-app"></app-header>
      <div class="container">
        <div class="top_block">
          <div class="flexbox user_box">
            <div class="flexbox user_icon">
              <img :src="userInfo.userAvtarUrl" alt="" />
              {{ userInfo.tel }}
            </div>
            <div v-if="userLevelStr" class="user_level">{{ userLevelStr }}</div>
          </div>
          <div class="flexbox tab_box" v-if="ptype !== 'trainVip'">
            <div class="tab_item" v-for="(item, index) in menu" :key="index" @click="setMindex(index)">
              <img :src="mIndex === index ? item.checkedUrl : item.url" alt="" />
            </div>
          </div>
        </div>
        <div class="camp_list">
          <campItem v-for="(item, index) in list" :key="index" :item="item" @onItem="onClickFn"></campItem>
        </div>
        <!-- 训练营预告 -->
        <img src="../../images/trainCamp/yugao.png" v-if="heraldList.length" class="herald_box" alt="" />
        <div class="camp_list" v-if="heraldList && heraldList.length">
          <campItem v-for="(item, index) in heraldList" :key="index" :item="item" @onItem="onClickFn"></campItem>
        </div>
        <div class="noData_box" v-if="!list.length && !heraldList.length">{{ noData }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { appUser } from '@/utils'
import campItem from './component/index.vue'
import { Toast } from 'vant'
import Body from '@/mixins/body'
import service from '@/api/modules/user'
import { toLoginView } from '@/utils/init/env-init'

export default {
  components: {
    campItem
  },
  data() {
    return {
      title: '友邻少年',
      mIndex: 0,
      userInfo: {},
      menu: [
        {
          url: require('../../images/trainCamp/ct.png'),
          checkedUrl: require('../../images/trainCamp/ct_checked.png')
        },
        {
          url: require('../../images/trainCamp/wx.png'),
          checkedUrl: require('../../images/trainCamp/wx_checked.png')
        }
      ],
      noData: '',
      ptype: 'trainCamp'
    }
  },
  mixins: [Body],
  computed: {
    ...mapGetters('trainCamp/index', ['list', 'heraldList', 'JoinTimes']),
    userLevelStr() {
      console.log(this.userVipCode)
      const { vipCode } = this.userInfo
      if (vipCode === 5) return '畅听卡会员'
      if (vipCode === 6) return '无限卡会员'
      return ''
    }
  },
  created() {
    this.ptype = this.$route.name
    // 如果没有登录，先去登录
    if (!this.hasUser()) {
      return
    }
    this.getUser()
  },
  methods: {
    // 检查用户
    hasUser() {
      const action = this.ptype || 'trainCamp'
      // 无token去登录
      if (!this.hasToken({ action })) {
        toLoginView({ type: 'button', action })
        console.log('toLoginView：false')
        return false
      }
      return true
    },
    // 微信登录后，再次获取体验营数据
    getWXUserAfter_getData() {
      console.log('训练营登录回调--------')
      this.getUser()
    },
    onClickFn({ item, type }) {
      if (type === 2) {
        /**
         * -1 : 身份不匹配
         * -2 : 报名未开始
         * -3 : 报名已结束
         * -4 : 已爆满
         * -5 : 没次数
         *  0 : 已报名
         *  1 : 可报名
         */
        // 先判断是否已报名
        const { campCourseType, joinStatus, campPeriodId, adviserErCode, joinMessage } = item
        if (joinStatus === 0 && adviserErCode) {
          return this.goNext(campPeriodId, item)
        }
        console.log(joinStatus)
        switch (joinStatus) {
          case -1:
            Toast(
              `该服务为${
                campCourseType === 51
                  ? '畅听卡与无限卡会员'
                  : campCourseType === 3 || campCourseType === 31
                  ? '畅听卡'
                  : '无限卡'
              }会员专享`
            )
            return
          case -2:
            Toast('当前营期报名未开始')
            return
          case -3:
            Toast('当前营期报名已结束')
            return
          case -4:
            Toast('当前营期已报满')
            return
          case -5:
            Toast('本年度报名次数已用完，无法继续报名～')
            return
          case -6:
            Toast('学习时间冲突，您已报名其他营期')
            return
          case -7:
            joinMessage && Toast(joinMessage)
            return
        }
      }
      this.$router.push({
        path: '/trainJoin',
        query: {
          goodsId: item.campPeriodId,
          joinStatus: item.joinStatus,
          callUpStatus: item.callUpStatus,
          campCourseType: item.campCourseType,
          JoinTimes: this.JoinTimes
        }
      })
    },
    goNext(goodsId, res) {
      this.$store.commit('payment/order/setPayStatus', {
        goodsId,
        ...res
      })
      this.$router.push({
        path: '/joinSuccess',
        query: {
          id: goodsId
        }
      })
    },
    setMindex(i) {
      this.mIndex = i
      this.getCamp()
    },
    getUser() {
      service.getUserDetail().then(res => {
        console.log('用户信息:', res)
        const { vipCode, mobileNo } = res
        const reg = /^(\d{3})\d{4}(\d{4})$/
        res.tel = mobileNo.replace(reg, '$1****$2')
        this.userInfo = res
        this.mIndex = vipCode === 6 ? 1 : 0
        // 暂时隐藏畅听卡训练营
        // this.mIndex = 1
        this.getCamp()
      })
    },
    getCamp() {
      console.log(appUser)
      this.$store
        .dispatch('trainCamp/index/periodsList', {
          campCourseType:
            this.ptype === 'trainVip'
              ? 51
              : this.ptype === 'trainActivity'
              ? this.mIndex === 0
                ? 31
                : 41
              : this.mIndex === 0
              ? 3
              : 4
        })
        .catch(err => {
          console.log('err---', err.data.errorCode)
          const errorCode = err.data.errorCode
          if (errorCode === 40400) this.noData = '暂无营期'
        })
    }
  }
}
</script>

<style lang="less" scoped>
.user_box {
  padding: 0.2rem 0 0.32rem;
  font-size: 0.26rem;
  font-weight: 400;
  color: #ffffff;
  .user_icon {
    margin-right: 0.16rem;
    img {
      display: block;
      width: 0.64rem;
      height: 0.64rem;
      border-radius: 50%;
      border: 0.02rem solid #ffffff;
      margin-right: 0.24rem;
    }
  }
  .login_box {
    margin-left: 10px;
  }
}
.container_box {
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('../../images/trainCamp/campBG.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  overflow: scroll;
  -webkit-overflow-scrolling: touch; // 解决view滑动速度慢或者卡顿问题
}
.container {
  padding: 0 0.48rem;
  .top_block {
    // padding: 0 0.48rem;
    // position: sticky;
    // top:0;
    // left: 0;
  }
  .tab_box {
    justify-content: space-between;
    padding-bottom: 0.48rem;
    .tab_item {
      width: 45%;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
  }
  .herald_box {
    display: block;
    width: 0.86rem;
    height: 0.48rem;
    margin: 0.48rem 0 0.32rem;
  }
}
.noData_box {
  position: absolute;
  top: 40%;
  left: 50%;
  transform: translate(-50%);
  color: #fff;
}
</style>
